var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.25 14h17.5c.331 0 .65-.158.884-.44.234-.28.366-.662.366-1.06s-.132-.78-.366-1.06c-.235-.282-.553-.44-.884-.44H3.25c-.332 0-.65.158-.884.44A1.67 1.67 0 0 0 2 12.5c0 .398.132.78.366 1.06.235.282.552.44.884.44"
  })));
};
export default SvgMinus;